import React from 'react';

const Documentation = () => {
    return (
        <div>
            Page documentation
        </div>
    );
};

export default Documentation;